<img src="../../../../assets/images/icon/live.png" alt="" data-toggle="tooltip" data-placement="bottom" title="คลิ๊กเพื่อเข้าชม" (click)="live()">